module.exports = __webpack_public_path__ + "img/slotmachine.5b1d3409.png";